define('plugin/back-to-site/view/BackToSiteView',['require','lib/view/LayoutView','lib/Utils'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    return LayoutView.extend({

        template: '#back_to_site_view',

        _timeout: 0,
        _start: 0,
        _timer: null,

        initialize: function () {
            this.listenTo(this.model, 'sync', this.setupTimer);
            this.setupTimer();
        },

        setupTimer: function () {
            this._timeout = this.model.get('timeout');
            this._start = new Date().getTime();

            if (this.model.get('timer_enabled')) {
                this._timer = setInterval(_.bind(this.handleTimer, this), 500);
            }
            this.render();
        },

        handleTimer: function () {
            if (!this.isDestroyed) {
                this.render();
            } else {
                clearInterval(this._timer);

                return;
            }
            if (this._getLeftTime() > this._timeout) {
                if (Utils.isMobile() && this.model.get('mobile_link') != '') {
                    top.window.location = this.model.get('mobile_link');
                } else {
                    top.window.location = this.model.get('link');
                }

                if (this._timer) {
                    clearInterval(this._timer);
                }
            }
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.seconds_to_redirect = Math.max(0, parseInt(this._timeout - this._getLeftTime()));

            return result;
        },

        _getLeftTime: function () {
            return (new Date().getTime() - this._start) / 1000;
        }

    });

});
